// 通过a标签元素下载 
export const downloadFile = (url, fileName, blob = null) => {
  const filename = fileName || 'download.xlsx';
  const blobContent = blob || new Blob([url]);
  const downloadElement = document.createElement('a');

  const href = window.URL.createObjectURL(blobContent); // 创建下载的链接
  downloadElement.href = href;
  downloadElement.download = filename;

  document.body.appendChild(downloadElement);
  downloadElement.click(); // 点击下载
  document.body.removeChild(downloadElement); // 下载完成移除元素
  window.URL.revokeObjectURL(href);
};

// 通过完整url下载文件(兼容IE、其他浏览器下载)
export const downloadFiles = (url, fileName) => {
  const filename = fileName || 'download.xlsx';
  const x = new XMLHttpRequest();
  x.open('GET', url, true);
  x.responseType = 'blob';
  // eslint-disable-next-line func-names
  x.onload = () => {
    const blob = x.response;
    if ('msSaveOrOpenBlob' in navigator) { // IE导出
      window.navigator.msSaveOrOpenBlob(blob, filename);
    } else {
      downloadFile(url, fileName, blob);
    }
  };
  x.send();
};

/**
 * 通过iframe元素下载完整的url
 * @param {*} url 下载地址
 * @param {*} key key值
 * @param {*} triggerDelay 当前下载延迟时间
 * @param {*} removeDelay 移除延迟时间
 */
export const downloadFileIframe = (url, key, triggerDelay = 0, removeDelay = 100) => {
  setTimeout(() => {
    // 动态添加iframe,设置src,然后删除
    const frame = document.createElement('iframe'); // 创建iframe
    frame.setAttribute('style', 'display: none');
    frame.setAttribute('src', url);
    frame.setAttribute('id', key);
    document.body.appendChild(frame);
    setTimeout(() => {
      const node = document.getElementById(key);
      node.parentNode.removeChild(node);
    }, removeDelay);
  }, triggerDelay);
};
